import { defaultEmailOption, phoneNumberOption } from '../../data-types/login/loginConstants';
import { LoginActionType, LoginState, SET_FROM_APP_FLAG, SET_IS_LOGGING_IN_FROM_REDIRECT, SET_LOGIN_OPTIONS } from '../types/loginTypes';
import { RESET_STATE } from '../types/stateTypes';

export const initialLoginState: LoginState = {
  loginOptions: [defaultEmailOption, phoneNumberOption],
  isLoggingInFromRedirect: false,
  isFromApp: false,
};

export const loginReducer = (state = initialLoginState, action: LoginActionType): LoginState => {
  switch (action.type) {
    case RESET_STATE:
      return {
        ...initialLoginState,
      };
    case SET_LOGIN_OPTIONS: {
      return { ...state, loginOptions: action.meta };
    }
    case SET_IS_LOGGING_IN_FROM_REDIRECT: {
      return { ...state, isLoggingInFromRedirect: action.meta };
    }
    case SET_FROM_APP_FLAG: {
      return { ...state, isFromApp: action.meta };
    }
    default:
      return state;
  }
};
